'use client'

import { usePathname } from 'next/navigation'
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes'
import * as React from 'react'

const forcedThemesRoutes: Record<string, string> = {
  '/auth/onboarding': 'light',
  '/auth/onboarding/customize': 'light',
  '/auth/onboarding/intent': 'light',
  '/auth/login': 'light',
  '/auth/signup': 'light',
  '/auth/forgot-password': 'light',
  '/auth/forgot-password/reset': 'light',
  '/auth/signup/check-email': 'light',
  '/auth/signup/success': 'light',
  '/checkout/start': 'light',
  '/checkout/success': 'light',
  '/checkout/set-organization': 'light',
  '/checkout/resubscribe': 'light',
  '/auth/organization/onboarding': 'light',
  '/auth/organization/onboarding/welcome': 'light',
  '/auth/organization/onboarding/sso': 'light',
  '/user/update': 'light',
}

export default function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const pathname = usePathname()
  const isForcedThemeRoute = pathname! in forcedThemesRoutes
  return (
    <NextThemesProvider {...(isForcedThemeRoute && { forcedTheme: forcedThemesRoutes[pathname!] })} {...props}>
      {children}
    </NextThemesProvider>
  )
}
